import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Pricing } from "@/components/site/Pricing";
import { About } from "@/components/site/About";
import { WhyChoose } from "@/components/site/WhyChoose";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MobileBottomBar } from "@/components/site/MobileBottomBar";

function App() {
  return (
    <div className="App min-h-screen bg-white pb-16 md:pb-0" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Services />
        <ServiceArea />
        <Pricing />
        <About />
        <WhyChoose />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}

export default App;
